export default __webpack_public_path__ + "static/media/school.087f34e6.jpg";